import React, { useState, useEffect } from "react";
import "./basketballIinstructions.css";
import home_background1 from '../../Assets/Images/home/banner.png';


import StaticPageHeaders from "../../Components/StaticPageHeaders";
import VideoBanner from "../../Components/BasketballInstruction/VideoBanner/VideoBanner"; 
import Team from "../../Components/Team/Team";
import UnlimitedBannerCom from "../../Components/InstructionsCom/UnlimitedBannerCom";
import Gallery from "../../Components/Home/Gallery/Gallery";
import Sponsors from "../../Components/Home/Sponsers/Sponsers";


import BasketBallInstructionBlock from "../../Components/BasketballInstruction/BasketBallInstructionBlock/BasketBallInstructionBlock";

import img1 from "../../Assets/Images/BasketBallInstruction/bi_1.png";
import img2 from "../../Assets/Images/BasketBallInstruction/bi_3.png";
import img3 from "../../Assets/Images/BasketBallInstruction/bi_3.png";
import img4 from "../../Assets/Images/BasketBallInstruction/bi_4.png";
import { InstructionsContextProvider } from "../../APIContext/InstructionsContext";
import { useNavigate } from "react-router-dom";
import Packages from "../../Components/BasketballInstruction/Packages/Packages";
import bg_right from "../../Assets/Images/BasketBallInstruction/right.png";
import bg_left from "../../Assets/Images/BasketBallInstruction/left.png";
import { useInstructions } from "../../APIContext/InstructionsContext";

import bg_un from "../../Assets/Images/TeamWorkout/team_work_unlim.png";
import SEO from "../../Components/SEO";








const SuccessStoriesBlocktwo = [
  {
    image: img1,
    name: "Group Instruction",
    description: "When you purchase a package of Group Instruction Sessions you are subject to be in a group with 3 other players that are on your skill level or in your age group. The maximum ration we allow in our group sessions is 8:1 students to instructors.. All of our scheduling is done manually to ensures that the groups are appropriate.",
    benifits:[
      "Group Instruction",
      "Group Instruction",
      "Come in every day that we train for 1 hour (max) (4-5 times a week)",
      "Come in every day that we train for 1 hour (max) (4-5 times a week)",
      
    ],
    orders: "left",
    bg: bg_left,
    buttonText:"Select Package",
    buttonLink:""
  },
  {
    image: img2,
    name: "Individual Instruction",
    description: "When you purchase a package of Group Instruction Sessions you are subject to be in a group with 3 other players that are on your skill level or in your age group. The maximum ration we allow in our group sessions is 8:1 students to instructors.. All of our scheduling is done manually to ensures that the groups are appropriate.",
    benifits:[],
    orders: "right",
    bg: bg_right,
    buttonText:"Select Package",
    buttonLink:""
  },
  {
    image: img3,
    name: "Unlimited Instruction Plan",
    description: "When you purchase a package of Group Instruction Sessions you are subject to be in a group with 3 other players that are on your skill level or in your age group. The maximum ration we allow in our group sessions is 8:1 students to instructors.. All of our scheduling is done manually to ensures that the groups are appropriate.",
    benifits:[
      "Group Instruction",
      "Group Instruction",
      "Come in every day that we train for 1 hour (max) (4-5 times a week)",
      "Come in every day that we train for 1 hour (max) (4-5 times a week)",
    ],
    orders: "left",
    bg: bg_left,
    buttonText:"Select Package",
    buttonLink:""
  },
  {
    image: img4,
    name: "Group Instruction",
    description: "When you purchase a package of Group Instruction Sessions you are subject to be in a group with 3 other players that are on your skill level or in your age group. The maximum ration we allow in our group sessions is 8:1 students to instructors.. All of our scheduling is done manually to ensures that the groups are appropriate.",
    benifits:[],
    orders: "right",
    bg: bg_right,
    buttonText:"Select Package",
    buttonLink:""
  }
];



const BasketBallInstructions = () => {
  const { packages, fetchGroupInstructions } = useInstructions();
  const [linl1, setLink1] = useState(``);
  const [linl2, setLink2] = useState(``);
  const [linl3, setLink3] = useState(``);

  useEffect(() => {
    fetchGroupInstructions()
  }, [])

  useEffect(() => {
  if (!packages || packages.length === 0) return;

  let link1 = "";
  let link2 = "";
  let link3 = "";

  packages.forEach((pkg) => {
    if (pkg.display_order === 0) {
      link1 = `/group-instruction?id=${pkg.id}`;
    }
    if (pkg.display_order === 1) {
      link2 = `/individual-instruction?id=${pkg.id}`;
    }
    if (pkg.display_order === 2) {
      link3 = `/unlimited-instruction?id=${pkg.id}`;
    }
  });

  setLink1(link1);
  setLink2(link2);
  setLink3(link3);

}, [packages]);
  

  const navigate = useNavigate();
  const images = [
    home_background1
    
  ];

   const [index, setIndex] = useState(0);
    useEffect(() => {
      const interval = setInterval(() => {
        setIndex((prevIndex) => (prevIndex + 1) % images.length);
      }, 3000); // Change image every 3 seconds
  
      return () => clearInterval(interval); // Cleanup on unmount
    }, [images.length]);

    
  return (

    // <iframe width="560" height="315" src="https://www.youtube.com/embed/ubFXs6VDckc?si=eou3n1DpSqkIDM1q" title="YouTube video player" frameborder="0" allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share" referrerpolicy="strict-origin-when-cross-origin" allowfullscreen></iframe>
    <>

    <SEO
      title="Instruction - Shootin School Basketball"
      description=""
      url="https://shootinschool.com/instruction/"
    />
    <div className="bi-page">
      <StaticPageHeaders title="BasketBall Instructions" />

     
        <VideoBanner 
          videoUrl="https://www.youtube.com/embed/ubFXs6VDckc?si=eou3n1DpSqkIDM1q"
          heading="Staten island’s Premier Basketball Instruction"
          
          buttonText1="Group ( 8:1 Ratio)"
          buttonLink1={linl1}
          buttonText2="Individual (1 on 1)"
          buttonLink2={linl2}
          buttonText3="Unlimited"
          buttonLink3={linl3}
      /> 
      
      

      <InstructionsContextProvider>
            <Packages />
      </InstructionsContextProvider>

      <div className="bi-container">
            <div className="bi-sss-layout">
        
                <div className="sss-grid" style={{marginTop: "30px"}}>
                  <InstructionsContextProvider>
                        <BasketBallInstructionBlock />
                  </InstructionsContextProvider>
                   
                </div>
            </div>
        </div>

        


      
      <UnlimitedBannerCom brValue={1.28} />
      <Gallery />
      <Sponsors />
    </div>
    </>
  );
};

export default BasketBallInstructions;
